import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadProjetoRevisaoArquivoUseCase } from "../../../presentation/useCases/read/download_projeto_revisao_arquivo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DownloadProjetoRevisaoArquivoUseCase
 */

export class DownloadProjetoRevisaoArquivoUseCase implements IDownloadProjetoRevisaoArquivoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(idProjetoRevisaoArquivo: number, nroArquivo: number, nomeArquivo: string)
    : Promise<void> {
    const result = await this.repository.downloadProjetoRevisaoArquivoById(idProjetoRevisaoArquivo, nroArquivo);
    await downloadFromBlobUrl(result, nomeArquivo);

  }
}
